import { UIPatchNotes } from '../../../../shared/scripts/patch_notes/UIPatchNotes.ts';
import { UICheckoutPageController } from '../../../../shared/scripts/ui_checkout/UICheckoutPageController.ts';
import { UIMFullscreenPageView } from '../../ui_page/UIMFullscreenPageView.ts';
import { UIChampionship25Controller } from '../../../../shared/scripts/ui_cc/UIChampionship25Controller.ts';
import { UIChampionship26Controller } from '../../../../shared/scripts/ui_cc/UIChampionship26Controller.ts';
import { HelplyLoader } from '../../../../shared/scripts/HelplyLoader.ts';
export class UIMSingletonPageView extends UIMFullscreenPageView {
    static getTitleFromPageType(pathname) {
        if (pathname.includes('/faq')) return {
            key: 'strings:homePage.footer.faq'
        };
        if (pathname.includes('/terms')) return {
            key: 'strings:homePage.singletonPages.terms'
        };
        if (pathname.includes('/about')) return {
            key: 'strings:homePage.footer.about'
        };
        if (pathname.includes('/careers')) return {
            key: 'strings:homePage.footer.careers'
        };
        if (pathname.includes('/values-examples')) return {
            key: 'strings:homePage.singletonPages.valuesExamples'
        };
        if (pathname.includes('/values')) return {
            key: 'strings:homePage.singletonPages.values'
        };
        if (pathname.includes('/checkout')) return {
            key: 'strings:homePage.singletonPages.checkout'
        };
        if (pathname.includes('/community')) return {
            key: 'strings:homePage.footer.community'
        };
        if (pathname.includes('/patch-notes')) return {
            key: 'strings:homePage.singletonPages.patchNotes'
        };
        if (pathname.includes('/press-kit')) return {
            key: 'strings:homePage.singletonPages.pressKit'
        };
        if (pathname.includes('/refund-policy')) return {
            key: 'strings:homePage.singletonPages.refundPolicy'
        };
        if (pathname.includes('/privacy-policy')) return {
            key: 'strings:homePage.singletonPages.privacyPolicy'
        };
        if (pathname.includes('/championship2025')) return {
            key: 'strings:homePage.footer.championship25'
        };
        if (pathname.includes('/championship2026')) return {
            key: 'strings:homePage.footer.championship26'
        };
        return {
            key: 'strings:colonistCommon.utils.emptyString'
        };
    }
    buildView() {
        void this.setContent();
    }
    async setContent() {
        const url = `/singleton${this.pathname}`;
        const response = await fetch(url);
        const content = await response.text();
        // eslint-disable-next-line no-restricted-syntax
        this.body.innerHTML = content;
        this.loadController();
    }
    removeFromDOM() {
        HelplyLoader.hide();
        super.removeFromDOM();
    }
    addQueryParameters() {
        const url = window.location.origin + this.pathname;
        const parsedUrl = new URL(url);
        window.history.pushState(undefined, '', parsedUrl.search);
    }
    loadController() {
        if (this.pathname.includes('/checkout')) {
            new UICheckoutPageController();
        } else if (this.pathname.includes('/patch-notes')) {
            new UIPatchNotes(null);
        } else if (this.pathname.includes('/championship2025')) {
            new UIChampionship25Controller();
        } else if (this.pathname.includes('/championship2026-form')) {
            this.loadHubSpotForm();
        } else if (this.pathname.includes('/championship2026')) {
            new UIChampionship26Controller();
        } else if (this.pathname.includes('/faq')) {
            HelplyLoader.initForFaqPage();
        }
    }
    loadHubSpotForm() {
        var _Object_entries_find;
        const formIds = {
            /* eslint-disable @typescript-eslint/naming-convention */ '/championship2026-form-application': '4f1ab7b8-d3a1-4b8d-a876-563fe037f76b',
            '/championship2026-form-announcement': '4219de75-89e3-48e5-8b62-d9ac685d241f',
            '/championship2026-form-result': 'a029ec73-d113-4ae5-8990-feb9fbc1c885'
        };
        const formId = (_Object_entries_find = Object.entries(formIds).find(([route])=>this.pathname.includes(route))) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[1];
        if (!formId) return;
        const hubSpotHosts = [
            'https://js-eu1.hsforms.net',
            'https://forms-eu1.hsforms.com',
            'https://forms-eu1.hscollectedforms.net'
        ];
        for (const host of hubSpotHosts){
            const link = document.createElement('link');
            link.rel = 'preconnect';
            link.href = host;
            document.head.appendChild(link);
        }
        const createForm = ()=>{
            if (window.hbspt == undefined) return;
            window.hbspt.forms.create({
                region: 'eu1',
                portalId: '146823366',
                formId: formId,
                target: `#hs-form-container`
            });
        };
        if (window.hbspt != undefined) {
            createForm();
        } else {
            const script = document.createElement('script');
            script.async = true;
            script.charset = 'utf-8';
            script.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
            script.onload = createForm;
            document.head.appendChild(script);
        }
    }
    constructor(pathname, backButtonAction){
        super(UIMSingletonPageView.getTitleFromPageType(pathname), pathname, backButtonAction);
        this.pathname = pathname;
        this.addQueryParameters();
    }
}
